/*
  Review italics
  --------------
  Book titles are italicised in the sliding reviews, following normal editorial
  style. Three things get italicised:

    1. Whatever follows "author of" in a credit line. Every credit in the
       catalogue is of the form "author of <Book>", including ones with awkward
       punctuation ("author of Do You Mind If I Cancel?: (Things That Still
       Annoy Me)"), so the whole remainder is the title.
    2. The book's own title where it appears in the review text.
    3. Anything a person wraps in *asterisks*, as an escape hatch for other
       titles the automatic match cannot know about.

  Matching is deliberately forgiving, because the source data is not consistent.
  Two reviews of the same book write it as "The End of My Life Is Killing Me"
  and "The End of My Life is Killing Me". Case, curly versus straight quotes,
  dash style, and runs of whitespace are all normalised. A review that
  paraphrases or shortens a title still needs the asterisks.

  This runs on rendered text nodes only, so it can never break the surrounding
  markup, and if it fails the review still reads correctly, just unstyled.
*/
(function () {
  'use strict';

  /* Matches "author of", "coauthors of", "New York Times bestselling author of".
     Deliberately narrow: credits like "owner of The Bookshelf, Irvine" name a
     shop, not a book, so a general "<something> of" rule would italicise the
     wrong thing. Anything this misses can be marked with *asterisks*. */
  var CREDIT_PREFIX = /\bco-?authors? of\s+|\bauthors? of\s+/i;

  function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /* Build a pattern that tolerates the ways the same title gets typed, with word
     boundaries so a short title like "Burst" cannot match inside "bursting". */
  function titlePattern(title) {
    var body = escapeRegex(title)
      .replace(/['’‘`]/g, "['’‘`]")
      .replace(/["“”]/g, '["“”]')
      .replace(/[-–—]/g, '[-–—]')
      .replace(/\s+/g, '\\s+');

    if (/^\w/.test(title)) body = '\\b' + body;
    if (/\w$/.test(title)) body = body + '\\b';
    return body;
  }

  function textNodesIn(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentNode && node.parentNode.closest('em, i, script, style')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    return nodes;
  }

  /* Replace matches inside a text node with <em>, leaving everything else alone. */
  function emphasise(node, pattern) {
    var text = node.nodeValue;
    pattern.lastIndex = 0;
    if (!pattern.test(text)) return false;

    pattern.lastIndex = 0;
    var fragment = document.createDocumentFragment();
    var cursor = 0;
    var match;

    while ((match = pattern.exec(text)) !== null) {
      if (match.index > cursor) {
        fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
      }
      var em = document.createElement('em');
      em.textContent = match[0];
      fragment.appendChild(em);
      cursor = match.index + match[0].length;
      if (match[0].length === 0) pattern.lastIndex++; // guard against zero-width loops
    }

    if (cursor < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
    }

    node.parentNode.replaceChild(fragment, node);
    return true;
  }

  function italiciseAsterisks(root) {
    textNodesIn(root).forEach(function (node) {
      var text = node.nodeValue;
      if (text.indexOf('*') === -1) return;
      var fragment = document.createDocumentFragment();
      var pattern = /\*([^*]+)\*/g;
      var cursor = 0;
      var match;
      var found = false;

      while ((match = pattern.exec(text)) !== null) {
        found = true;
        if (match.index > cursor) fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
        var em = document.createElement('em');
        em.textContent = match[1];
        fragment.appendChild(em);
        cursor = match.index + match[0].length;
      }

      if (!found) return;
      if (cursor < text.length) fragment.appendChild(document.createTextNode(text.slice(cursor)));
      node.parentNode.replaceChild(fragment, node);
    });
  }

  /* "Will Schwalbe, author of The End of Your Life Book Club" */
  function italiciseCredit(element) {
    if (element.dataset.italicsDone === 'true') return;
    var text = element.textContent.replace(/\s+/g, ' ').trim();
    var match = text.match(CREDIT_PREFIX);
    if (!match) return;

    var splitAt = text.indexOf(match[0]) + match[0].length;
    var lead = text.slice(0, splitAt);
    var title = text.slice(splitAt).trim();
    if (!title) return;

    element.textContent = '';
    element.appendChild(document.createTextNode(lead));
    var em = document.createElement('em');
    em.textContent = title;
    element.appendChild(em);
    element.dataset.italicsDone = 'true';
  }

  function run(scope) {
    var sliders = (scope || document).querySelectorAll('[data-review-italics]');

    Array.prototype.forEach.call(sliders, function (slider) {
      var productTitle = (slider.dataset.productTitle || '').trim();

      /* The full title first, then the part before a subtitle colon, since
         reviews often drop the subtitle. */
      var candidates = [];
      if (productTitle) {
        candidates.push(productTitle);
        var colon = productTitle.indexOf(':');
        if (colon > 3) candidates.push(productTitle.slice(0, colon).trim());
      }

      Array.prototype.forEach.call(slider.querySelectorAll('.zb-reviews-slider-content'), function (content) {
        if (content.dataset.italicsDone === 'true') return;
        for (var i = 0; i < candidates.length; i++) {
          var pattern = new RegExp(titlePattern(candidates[i]), 'gi');
          var hit = false;
          textNodesIn(content).forEach(function (node) {
            if (emphasise(node, pattern)) hit = true;
          });
          if (hit) break; // the fuller title won; do not also match its prefix
        }
        italiciseAsterisks(content);
        content.dataset.italicsDone = 'true';
      });

      Array.prototype.forEach.call(slider.querySelectorAll('.zb-reviews-slider-tagline'), italiciseCredit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) { run(event.target); });
})();
